export default __webpack_public_path__ + "static/media/countdown-header.54240888.png";